import { useScreenMessage } from '@gogame/screens';

import { loadGridPresets } from 'scenes/HomeDashboard/sources/grid';

export const useLoadGridPresets = process => {
  const { showErrorMessage } = useScreenMessage();

  return params =>
    process(loadGridPresets(params)).catch(e => {
      showErrorMessage(e.message, { multiple: Array.isArray(e.message) });
      return Promise.reject(e);
    });
};
